import StringUtil from 'gw-portals-util-js/StringUtil';
import _VMListNode from './_VMListNode';
import _VMNode from './_VMNode';
import _AncestorChainFactory from './_AncestorChainFactory';
import _Step from './build/_Step';
/**
 * Return a factory to create new view model objects using registered aspects
 *
 * @param {Array} aspects : Aspect factory objects that have been registered with the ViewModel API
 * @param {Object} config : configuration for VM factory
 *
 * @returns {Object}: A factory object with a create function for creating new view model objects
 **/
export default (function (aspects, config) {
    function createRootViewModelNode(modelRoot, metadataInfo) {
        var VMNode = _VMNode(modelRoot, aspects, config);
        var VMListNode = _VMListNode(VMNode, createViewModelNode);

        var viewModelNode = new VMNode(metadataInfo, _AncestorChainFactory.emptyChain);

        function setDTOProperty(dtoViewModel, propertyName, propertyMetadataInfo, propertyAncestorChain) {
            var node = null;
            Object.defineProperty(dtoViewModel, propertyName, {
                get: function get() {
                    if (!dtoViewModel.value) {
                        return;
                    }

                    if (node) {
                        return node;
                    }

                    // create node lazily if parent node has a value
                    node = createViewModelNode(dtoViewModel, propertyName, _Step.property(propertyMetadataInfo.dtoType.xCenter.name, propertyMetadataInfo), propertyAncestorChain);
                    return node;
                },
                set: function set(vmNodeOrModel) {
                    if (!node) {
                        node = createViewModelNode(dtoViewModel, propertyName, _Step.property(propertyMetadataInfo.dtoType.xCenter.name, propertyMetadataInfo), propertyAncestorChain);
                    }

                    node.set(vmNodeOrModel);
                },
                enumerable: true
            });
        }

        /* Set view model nodes for properties of a DTO view model node */
        function setDTOProperties(_viewModelNode) {
            var pathBuilder = _AncestorChainFactory.build(_viewModelNode, _viewModelNode._metadataInfo, _viewModelNode._ancestorChain);
            var metadataProperties = _viewModelNode._metadataInfo.valueType.typeInfo.properties;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = metadataProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var properyMetadata = _step.value;

                    var propertyName = StringUtil.lowercaseFirstLetter(properyMetadata.name);
                    var propertyAncestorChain = pathBuilder.forChild(properyMetadata.name);
                    setDTOProperty(_viewModelNode, propertyName, properyMetadata, propertyAncestorChain);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        /* Create a view model node for the current metadata and ancestor chain. */
        function createViewModelNode(_parentViewModel, accessorCode, _metadataInfo, ancestorChain) {
            if (_metadataInfo.valueType.isCollection) {
                return new VMListNode(_metadataInfo, ancestorChain, accessorCode);
            }
            var _viewModelNode = new VMNode(_metadataInfo, ancestorChain, accessorCode);
            var typeInfo = _metadataInfo.valueType.typeInfo;
            if (typeInfo && typeInfo.metaType.isDto) {
                setDTOProperties(_viewModelNode, _metadataInfo, ancestorChain);
            }
            return _viewModelNode;
        }

        setDTOProperties(viewModelNode);
        return viewModelNode;
    }

    return {
        /**
         * Create a new view model object based on an object containing data and a metadata type
         *
         * @param {Object} modelRoot : initial data object for view model. Error thrown if data is not an object
         * @param {Object} metadataInfo : metadata information associated with the root model object
         *
         * @returns {Object}: A new view model object
         **/
        create: function create(modelRoot, metadataInfo) {
            return createRootViewModelNode(modelRoot, metadataInfo);
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/_VMFactory.js
// module id = 309
// module chunks = 0